import React, { Component, Fragment, useState, useEffect } from 'react';
import MainFilter from '../components/filters/MainFilter';
import { Card, CardBody, Row, Col, Progress, Table } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { categoryRequest, categoryGraphRequest, singleFloorFetch, employeSalesUnitRequest } from '../helpers/requests';
import Sections from './Templates/Sections';
import { setCategoryLoader, setCategoryFilter } from '../redux/actions/categoryActions';
import LineGraph from "../components/charts/LineGraph";
import Map from '../components/svg/map';

const Categories = () => {
  const [filters, setFilters] = useState();
  const [currentStore, setcurrentStore] = useState(null);
  const dispatch = useDispatch();
  const labels = useSelector((state) => state.categoryReducer.labels);
  const graphLabels = useSelector((state) => state.categoryReducer.graphLabels);
  const floors = useSelector((state) => state.floorReducer.floors)
  const data = useSelector((state) => state.categoryReducer.data);
  const graph = useSelector((state) => state.categoryReducer.graph);
  const currentFloor = useSelector((state) => state.floorReducer.floor)
  const [sections, setSections] = useState([])
  const [sectionSaleData, setSectionSaleData] = useState([])
  const employeSalesUnits = useSelector((state) => state.categoryReducer.employeSalesUnits);
  const totalTraffic = useSelector((state) => state.categoryReducer.totalTraffic)
  const [section, setSection] = useState();
  const [selectedSection, setSelectedSection] = useState();
  var filter = useSelector((state) => state.categoryReducer.filter);
  var loader = useSelector((state) => state.categoryReducer.loader);
  const user = useSelector((state) => state.auth.user);
  const [showMap, setShowMap] = useState(true);
  const stores = user.access.map((val, index) => {
    return { ...val, value: val._id, label: val.label };
  });

  console.log('totalTraffic', sectionSaleData);




  const updateFilter = (e) => {
    setFilters(e);
    e['dispatch'] = dispatch;

    let requestdata = e;
    console.log('requestdata', requestdata);
    let floorRequestdata = {
      _id: e.fid,
      dispatch
    }
    let _filter = {
      _startDate: e.start,
      _endDate: e.end,
      _fid: e.fid,
      _sid: e.sid
    }
    let employeSaleObject = {
      sid: requestdata.sid,
      start: requestdata.start,
      end: requestdata.end,
      dispatch
    }
    employeSalesUnitRequest(employeSaleObject)
    dispatch(setCategoryFilter(_filter));
    singleFloorFetch(floorRequestdata)
    setTimeout(() => {
      categoryRequest(requestdata);
      categoryGraphRequest(requestdata);
    }, 200);


  }

  const getBarLabels = () => {
    // return currentFloor?.sections.map((val, ind) => {
    //   return val.label;
    // });
    return graphLabels;
  }

  useEffect(() => {
    if (currentFloor) {
      setSection(currentFloor?.sections[0])
      setSelectedSection(currentFloor?.sections[0]?.label)
    }
  }, [currentFloor])


  useEffect(() => {
    if (section) {
      let obj = filters;
      if (typeof obj === "object") {
        obj['sec_id'] = section?._id
        categoryGraphRequest(obj);

      }
    }

  }, [section])

  useEffect(() => {
    if (floors) {
      let sections = [];
      floors.map((item) => {
        item.sections.map((section) => {
          sections.push({
            value: section._id,
            label: section.label

          })
        })
      })
      setSections(sections);
    }
  }, [floors])

  useEffect(() => {

    console.log('employeSalesUnits  totalTraffic', employeSalesUnits, totalTraffic);

    if (employeSalesUnits.length && totalTraffic.length) {

      let salesTrafficData = [];
      employeSalesUnits.filter((sales) => {
        return totalTraffic.find(traffic => {
          if (traffic._id === sales.sec_id) {
            salesTrafficData.push({
              ...sales, traffic: traffic.footfall, label: traffic.label
            })
          }
        })
      })
      setSectionSaleData(salesTrafficData);
      console.log('salesTrafficData', salesTrafficData);
    }
  }, [totalTraffic, employeSalesUnits])

  function getSelectedValueBack(data) {
    setSelectedSection(data);
  }

  return (
    <Fragment>
      <MainFilter pageTitle="Categories" updateFilter={(e) => updateFilter(e)} type='gold'></MainFilter>
      <Row >
        <Col>
          <h4 className="my-3">Sectionwise Dwelltime</h4>
        </Col>
      </Row>

      <Row>
        <Col style={{ height: "20px" }}>
          {
            loader &&
            <Progress animated className="mb-2" color="warning" value="100" style={{ height: '5px' }} />
          }
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <Card>
            <CardBody>
              {/* {console.log('section is',filtera.section)} */}
              {currentFloor &&
                <Sections setSection={(section) => setSection(section)} dye={currentFloor ? currentFloor.dye_image : ""} map={currentFloor ? currentFloor.image : ""} sections={currentFloor.sections ? currentFloor.sections : []} section={section ? section : ''} selectedSection={getSelectedValueBack} />
              }
            </CardBody>
          </Card>
        </Col>
        <Col md={6}>
          <Row className="mb-3" >
            <Col>
              {
                graph != null &&
                <LineGraph seriesData={{ data: graph, labels: labels }} hideControls={true} title={`Dwelltime For ${selectedSection} Section`} space={40} rotation={45} />
              }
            </Col>
          </Row>
          {filters && filters.sid != "6234c4d7115aa9163039ad5a" &&
            <>
              <Row className="mb-3">
                <Col>
                  {data &&

                    <LineGraph seriesData={{ data: data ? data[0] : new Array(getBarLabels().length).fill(0), labels: getBarLabels() }} hideControls={true} title={"Visitors For All Sections"} space={40} rotation={45} />
                  }
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  {data &&

                    <LineGraph seriesData={{ data: data ? data[1] : new Array(getBarLabels().length).fill(0), labels: getBarLabels() }} hideControls={true} title={"Average Dwelltime For All Sections"} space={40} rotation={45} />
                  }
                </Col>
              </Row>
            </>
          }

          {filters && filters.sid === "6234c4d7115aa9163039ad5a" &&
            <Row className="mb-3">
              <Col>

                <Table bordered style={{ fontSize: "40px", textAlign: "center", }}>
                  <thead>
                    <tr>
                      <th>Sections</th>
                      <th>Sale (in PKR)</th>
                      <th>Units</th>
                      <th>Transaction</th>
                      <th>Traffic</th>
                      <th>Conversion per Units% </th>
                      <th>Conversion Per Transaction</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      sectionSaleData?.length > 0 &&
                      sectionSaleData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.label}</td>
                          <td>{item.sale?.toFixed()}</td>
                          <td>{item.units}</td>
                          <td>{item.transaction}</td>
                          <td>{item.traffic}</td>
                          <td>{((item.units / item.traffic) * 100)?.toFixed(2)}</td>
                          <td>{((item.transaction / item.traffic) * 100)?.toFixed(2)}</td>

                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </Col>
            </Row>}
        </Col>
      </Row>
      {filters && filters.sid === "6234c4d7115aa9163039ad5a" &&
        <>
          <Row>
            <Col md={6}>
              <Row className="mb-3">
                <Col>
                  {data &&

                    <LineGraph seriesData={{ data: data ? data[0] : new Array(getBarLabels().length).fill(0), labels: getBarLabels() }} hideControls={true} title={"Visitors For All Sections"} space={40} rotation={45} />
                  }
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-3">
                <Col>
                  {data &&

                    <LineGraph seriesData={{ data: data ? data[1] : new Array(getBarLabels().length).fill(0), labels: getBarLabels() }} hideControls={true} title={"Average Dwelltime For All Sections"} space={40} rotation={45} />
                  }
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      }

    </Fragment>
  );
}
export default Categories;
